<template>
  <v-container max-width="500px" >
    <detail-card title="Πελάτης" :api="apipath" :nonBill=nonBill :cid="customer"></detail-card>
    <v-card class="mt-5 ma-3">
      <v-card-title>
        <h1 class="mr-2 grey--text">Οχημα</h1>
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col >
        <h3 class="mr-2 my-2  subheading grey--text">Αρ. Κυκλοφοριας: {{ vehicle.PlateNumber }}</h3>
          </v-col>
          <v-col >
          <h3 class="mr-2 my-2  subheading grey--text">VIN: {{ vehicle.Vin }}</h3>
          </v-col>
          <v-col >
          <h3 class="mr-2 my-2  subheading grey--text">Άξονες: {{ vehicle.AxleConfig }}</h3>
          </v-col>
          <v-col >
        <h3 class="mr-2 my-2 text-right subheading grey--text">Ετος: {{ vehicle.Year }}</h3>
          </v-col>
        </v-row>
        <v-row>
          <v-col >
          <h3 class="mr-2 my-2  subheading grey--text">Μαρκα: {{ vehicle.Make }}</h3>
          </v-col>
        </v-row>
      <v-row>
  <v-col cols="6">
    <v-text-field
      v-model="search"
      append-icon="mdi-magnify"
      clearable
      label="Search"
      dense
      outlined
      single-line
      hide-details
    ></v-text-field>
  </v-col>
  <v-col cols="6" class="text-right">
    <v-btn @click="downloadLog" color="primary" icon>
      <v-icon>mdi-download</v-icon>
    </v-btn>
    <v-switch v-model="service_log" label="Εργασία"/>
    <v-spacer/>
  </v-col>
</v-row>
   <v-tabs
      v-model="tab"
      center-active
    >
      <v-tab key="repairs">Επισκευες</v-tab>
      <v-tab key="parts">Ανταλλακτικα</v-tab>
    </v-tabs>

     <v-tabs-items v-model="tab">
      <v-tab-item key="repairs">
           <v-data-table
          :headers="headers"
          :items="carditems"
          item-key="itemcode"
          class="elevation-1"
          :loading="loading"
          single-expand: true
          :search="search"
          :expanded.sync="expanded"
          show-expand
          loading-text="Loading... Please wait"
        >
        <template v-slot:item.actions="{item}">
            <v-btn
              icon
              :to="{name: 'edit-repair',  params: {repairId: item.Id}}"
            >
             <v-icon>mdi-pencil</v-icon>
            </v-btn>
         </template>
         <template v-slot:item.RepairCost="{item}">
           {{ tocurr(item.RepairCost) }}
         </template>
         <template v-slot:item.Odometer="{item}">
           {{ item.Odometer }} χλμ.
         </template>

         <template v-slot:expanded-item="{ headers, item }">
          <td :colspan="headers.length">
            More info about {{ item.Id }}<br/>
            Σημειώσεις: <br/>
            {{ item.Notes }}
          </td>
         </template>

        </v-data-table>

      </v-tab-item>
      <v-tab-item key="parts">
           <v-data-table
          :headers="headers2"
          :items="parts"
          item-key="Id"
          :search="search"
          @click:row="handleClick"
          class="elevation-1"
          :loading="loading"
          loading-text="Loading... Please wait"
        >
         <template v-slot:item.Price="{item}">
           {{ tocurr(item.Price) }}
         </template>
        </v-data-table>

    </v-tab-item>
    </v-tabs-items>




     <v-divider></v-divider>
        <div class="text-right  py-10 ma-5">
          <p><b>Σύνολο Επισκευών:</b>&nbsp;  {{ vehicle.Repairs.length}}</p>
          <p><b>Κόστος αντ/κων:</b>&nbsp;  {{ tocurr(sumField(parts, "Price"))}}</p>
        </div>
      </v-card-text>

    </v-card>
  </v-container>
</template>

<script>
var orderBy = require('lodash/orderBy');
import DetailCard from "./DetailCard";
export default {
  props: {
    vehid: { required: true, type: String },
  },
  components: {
    DetailCard,
  },
  computed: {
    lineitems: function () {
      return orderBy(this.carditems, "Id");
    },
  },
  data() {
    return {
      loading: true,
      tab: "repairs",
      vehicle: {Repairs: []},
      expanded: [],
      customer: "",
      nonBill: false,
      apipath: "customers/",
      carditems: [],
      parts: [],
      search: '',
      service_log: false,
      headers: [
          {
            text: 'Α/A',
            align: 'start',
            //sortable: false,
            value: 'Id',
            width: '8%',
          },
          { text: 'Ημερομηνία', value: 'Date'},
          { text: 'Ένδειξη ταχογράφου', value: 'Odometer'},
          { text: 'Κόστος Επισκευής', value: 'RepairCost'},
          { text: 'Actions', value: 'actions' },
          { text: '', value: 'data-table-expand' },
        ],
    headers2: [
          {
            text: 'Α/A',
            align: 'start',
            //sortable: false,
            value: 'Id',
            width: '8%',
          },
          { text: 'Ημερομηνία', value: 'Timestamp'},
          { text: 'Περιγραφή', value: 'Description'},
          { text: 'Κωδ.', value: 'Sku'},
          { text: 'SKU', value: 'ManfSku'},
          { text: 'Ποσότητα', value: 'Qty' },
          { text: 'Τιμή', value: 'Price' },
          { text: 'Τεχν.', value: 'Technician.Name'},
        ],


    };
  },
  async created() {
    await this.fetchVehicle();
  },
  methods: {
    afm(afmnum) {
      return new String(Number(afmnum).toFixed()).padStart(9, "0");
    },
     handleClick(item) {
        this.$router.push({name: 'edit-repair', params: {repairId: item.RepairId}, target: '_blank'})
    },
    sumField(items, key) {
      // sum data in give key (property)
      return items.reduce((a, b) => a + (b[key] || 0), 0);
    },
    tocurr(value) {
      return new Intl.NumberFormat("el-GR", {
        style: "currency",
        currency: "EUR",
      }).format(value);
    },

 async downloadLog() {
    try {
      const response = await this.$api.get(`/repairs/vehicles/${this.vehid}/log`, {
        responseType: 'blob', // Important for handling binary data
        params: {service_log: this.service_log},
      });

      
      // Create a link element to download the file
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download',`ΔΕΛΤΙΟ ΧΡΕΩΣΗΣ ΑΝΤΑΛΛΑΚΤΙΚΩΝ - ${this.vehicle.PlateNumber}.docx`); // Specify the file name
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error('Error downloading the log:', error);
    }
  },

    async fetchVehicle() {
      try {
        console.log("veh_id: " + this.id);
        var resp = await this.$api.get("/repairs/vehicles/"+this.vehid);
        console.log(resp);
        this.vehicle = resp.data;
        this.carditems = resp.data.Repairs;

        var response = await this.$api.get("/repairs/vehicles/"+this.vehid+"/items");
        this.parts = response.data;

        this.loading = false;
        if (this.vehicle.Owner) {
           this.customer = this.vehicle.Owner.Id;
           this.nonBill = this.vehicle.Owner.Cid.startsWith('G') ? true : false;
        }
      } catch (error) {
        console.error(error);
      }
    },
  },
};
</script>

<style type="text/css" media="screen">
   width: 20%;
</style>
